import React from "react";
import PropTypes from "prop-types";
import NavBarLink from "./NavBarLink";
import LikesLink from "./LikesLink";
import MessagesButton from "./MessagesButton";
import ProfileButton from "./ProfileButton";
import BoostButton from "./BoostButton";
import DoubleTakeIcon from "./icons/DoubleTake.svg";
import DiscoverIcon from "./icons/Discover.svg";

import "./NavBar.scss";

const NavBar = ({ boostTokenCount, hasIncognitoEnabled }) => {
	const {
		location: { pathname },
	} = window;

	return (
		<div className="navbar-container">
			<span className="navbar">
				<h1 id="logo" className="nav-logo">
					<a href="/home">
						<span className="icon" aria-hidden="true" />
						<span className="text">OkCupid</span>
					</a>
				</h1>
				<NavBarLink
					isSelected={(pathname === "/doubletake") || pathname === "/quickmatch"}
					IconComponent={DoubleTakeIcon}
					text="DoubleTake"
					path="/doubletake"
				/>
				<NavBarLink
					isSelected={pathname === "/match"}
					IconComponent={DiscoverIcon}
					text="Browse"
					path="/match"
				/>
				<LikesLink
					isSelected={pathname === "/who-likes-you" || pathname === "/who-you-like"}
				/>
				<MessagesButton
					isSelected={pathname === "/messages"}
				/>
			</span>
			<span className="navbar">
				<ProfileButton />
				<BoostButton
					tokenCount={boostTokenCount}
					hasIncognitoEnabled={hasIncognitoEnabled}
				/>
			</span>
		</div>
	);
};

NavBar.defaultProps = {
	boostTokenCount: 0,
	hasIncognitoEnabled: false,
};

NavBar.propTypes = {
	boostTokenCount: PropTypes.number,
	hasIncognitoEnabled: PropTypes.bool,
};

export default NavBar;



// WEBPACK FOOTER //
// ./src/shared/components/NavBar/NavBar.jsx